(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/contextualmenu.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/contextualmenu.js'); 
svs.tipset.views.ContextMenu = Backbone.View.extend({

  initialize: function() {
    this.listenTo(svs.tipset.models.play, 'change', this.setSystemListener);

    var headerClass = svs.tipset.models.gameDefinitions.get('htmlClass') + '-modal-header';

    function showDialog(options) {
      var icon = options.icon || 'dustbin';
      var okAction = options.okAction || function() {};
      var dialogConfig = {
        actions: [
          {
            title: 'Avbryt'
          },
          {
            callback: function() {
              svs.components.dialog.api.close();
              okAction();
            },
            title: 'Fortsätt'
          }
        ],
        branding: svs.components.dialog.branding.SPORT,
        icon: icon,
        title: options.title
      };
      if (options.message) {
        dialogConfig.message = [{
          text: options.message,
          type: svs.components.dialog.message.TEXT
        }];
      }
      svs.components.dialog.api.add(new svs.components.dialog.Confirm(dialogConfig));
    }

    var contextMenuData = {
      clearAndToggleReduceMode: function() {
        if (svs.tipset.collections.matchlist.isAnySet()) {
          var self = this;
          showDialog({
            message: 'Vill du fortsätta ändå?',
            okAction: function() {
              svs.tipset.collections.matchlist.clearAll();
              svs.tipset.models.xpertenSystems.clearAll();
              svs.tipset.models.betslipFooter.resetBetslip();
              svs.tipset.models.systems.reset();
              self.toggleReduceMode();
            },
            title: 'Dina tecken kommer att rensas'
          });
        } else {
          svs.tipset.models.systems.reset();
          this.toggleReduceMode();
        }
      },

      onRensaTecken: function(callback) {
        showDialog({
          okAction: function() {
            if (svs.tipset.models.play.get('isSingleRow')) {
              svs.tipset.collections.boardCollections.clearAll();
              svs.tipset.models.xpertenSystemsSingleRow.clearAll();
            } else {
              var system = svs.tipset.models.systems.getCurrentSystem();

              svs.tipset.collections.matchlist.clearAll();
              svs.tipset.models.xpertenSystems.clearAll();
              svs.tipset.models.betslipFooter.resetBetslip();

              if (system) {
                svs.tipset.models.systems.setCurrentSystem(system);
                svs.tipset.views.actionbar.model.setSystem();
              }
            }
            if (callback) {
              callback();
            }
          },
          title: 'Vill du rensa dina tecken?'
        });
      },

      onSingleRowsToggle: function() {
        var hasAnySet;
        if (svs.tipset.models.play.get('isSingleRow')) {
          hasAnySet = svs.tipset.collections.boardCollections.isAnySet();
        } else {
          hasAnySet = svs.tipset.collections.matchlist.isAnySet();
        }

        if (hasAnySet) {
          showDialog({
            message: 'Vill du fortsätta ändå?',
            okAction: svs.tipset.models.play.toggleSingleRow,
            title: 'Dina tecken kommer att rensas'
          });
        } else {
          svs.tipset.models.play.toggleSingleRow();
        }
      },

      onSpelguide: function(tab) {
        svs.components.Modal.show(
          svs.tipset.views.Spelguide,
          { tab: tab },
          {
            headerClass: headerClass,
            leftButton: {
              cssClass: 'btn-transparent-inverted',
              text: 'Stäng',
              visible: true
            },
            rightButton: { visible: false },
            title: 'Spelguide'
          }
        );
      },

      onSystemspel: function() {
        svs.components.Modal.show(
          svs.tipset.views.System,
          { model: svs.tipset.models.systems },
          {
            headerClass: headerClass,
            leftButton: {
              cssClass: 'btn-transparent-inverted',
              visible: true
            },
            rightButton: {
              callback: function() {
                var _that = this;
                window.requestIdleCallback(function() {
                  _that.verifySystem();
                });
                return true;
              },
              cssClass: 'btn-transparent-inverted',
              text: 'Klar',
              visible: true
            },
            title: 'SYSTEMSPEL'
          }
        );
      },

      onTipsSM: function() {
        var hasAnySet;
        if (svs.tipset.models.play.get('isSingleRow')) {
          hasAnySet = svs.tipset.collections.boardCollections.isAnySet();
        } else {
          hasAnySet = svs.tipset.collections.matchlist.isAnySet();
        }

        if (hasAnySet) {
          showDialog({
            message: 'Vill du fortsätta ändå?',
            okAction: function() {
              svs.tipset.objects.localstorageHandler.clearLocalStorageFromStartPage(function() {
                if (svs.tipset.data.competition) {
                  window.location.href = svs.core.data.baseUrl;
                } else {
                  window.location.href = svs.core.data.baseUrl + '/tipssm';
                }
              });
            },
            title: 'Dina tecken kommer att rensas'
          });
        } else if (svs.tipset.data.competition) {
          window.location.href = svs.core.data.baseUrl;
        } else {
          window.location.href = svs.core.data.baseUrl + '/tipssm';
        }
      },

      onTipsinfo: function() {
        svs.components.Modal.show(
          svs.tipset.views.Tipsinfo,
          { model: svs.tipset.models.statistics },
          {
            contentClass: 'modal-content-default bg-white',
            headerClass: headerClass,
            leftButton: { visible: false },
            rightButton: {
              callback: function() {
                svs.tipset.models.statistics.handleStatisticChoices();
                return true;
              },
              cssClass: 'btn-transparent-inverted',
              text: 'Klar',
              visible: true
            },
            title: 'TIPSINFO'
          }
        );
      },

      onXperten: function() {
        var xpertModel = svs.tipset.models.play.get('isSingleRow') ?
          svs.tipset.models.xpertenSystemsSingleRow :
          svs.tipset.models.xpertenSystems;
        var shouldShowModalHistory =
          !svs.tipset.models.play.get('isSingleRow') &&
          svs.core.detect.formfactor.mobile();
        svs.components.Modal.show(
          svs.tipset.views.Xperten,
          { model: xpertModel },
          {
            headerClass: headerClass,
            leftButton: {
              callback: function() {
                return true;
              },
              cssClass: 'btn-transparent-inverted',
              visible: true
            },
            modalHistory: shouldShowModalHistory,
            rightButton: {
              callback: function() {
                if (svs.tipset.models.play.get('isSingleRow')) {
                  svs.tipset.models.xpertenSystemsSingleRow.getSystem();
                } else {
                  svs.tipset.models.xpertenSystems.getSystem();
                }
                return true;
              },
              cssClass: 'btn-transparent-inverted',
              disabled: true,
              text: 'Klar',
              visible: true
            },
            title: 'XPERTEN'
          }
        );
      },

      onXpertenRsystem: function() {
        svs.components.Modal.show(
          svs.tipset.views.Xperten,
          { model: svs.tipset.models.xpertenSystems },
          {
            headerClass: headerClass,
            leftButton: {
              callback: function() {
                return true;
              },
              cssClass: 'btn-transparent-inverted',
              visible: true
            },
            rightButton: {
              callback: function() {
                svs.tipset.models.xpertenSystems.getSystem();
                return true;
              },
              cssClass: 'btn-transparent-inverted',
              disabled: true,
              text: 'Klar',
              visible: true
            },
            title: 'XPERTEN R-SYSTEM'
          }
        );
      },

      toggleReduceMode: function() {
        if (svs.tipset.models.play.get('isReduceMode')) {
          svs.tipset.models.play.disableReduceMode();
        } else {
          svs.tipset.models.play.enableReduceMode();
        }
        svs.tipset.views.actionbar.model.setSystem();
      }
    };

    this.onXperten = contextMenuData.onXperten;
    this.onSystemspel = contextMenuData.onSystemspel;
    this.onSpelguide = contextMenuData.onSpelguide;
    this.onTipsinfo = contextMenuData.onTipsinfo;
    this.onSingleRowsToggle = contextMenuData.onSingleRowsToggle;
    this.onRensaTecken = contextMenuData.onRensaTecken;
    this.onXpertenRsystem = contextMenuData.onXpertenRsystem;

    svs.utils.initContextMenu = function(options) {
      var isSystem =
        svs.tipset.models.systems &&
        svs.tipset.models.systems.getCurrentSystem();
      var systemType = isSystem ?
        svs.tipset.models.systems.getCurrentSystem().type :
        undefined;
      var isRsystem = systemType === svs.tipset.constants.SYSTEM_TYPE.R_SYSTEM;
      var isUsystem = systemType === svs.tipset.constants.SYSTEM_TYPE.U_SYSTEM;
      var isCompetition =
        svs.tipset.models.competition &&
        svs.tipset.models.competition.getCompetitionMode() ?
          svs.tipset.models.competition.getCompetitionMode() :
          false;
      var hasDraws =
        svs.utils.ns.isNamespace('svs.tipset.collections.draws') &&
        svs.tipset.collections.draws.length > 0;
      var isOpenDraw = hasDraws ?
        svs.tipset.collections.draws.getCurrentDraw().getIsOpen() :
        false;
      this.isStartPage = options ? options.isStartPage : false;

      var disableXperten =
        !isOpenDraw ||
        isUsystem ||
        svs.tipset.models.play.get('isReduceMode');
      var productName = svs.tipset.models.gameDefinitions
        .get('productName')
        .toLowerCase();
      var cssClass = 'contextual-menu-swipe-button-' + productName;

      contextMenuData.leftButtons = [];
      contextMenuData.leftButtonsInBlock = true;
      if (!svs.core.detect.formfactor.mobile() && !isCompetition) {
        contextMenuData.leftButtons.push({
          active: svs.tipset.models.play && svs.tipset.models.play.get('isSingleRow'),
          callback: contextMenuData.onSingleRowsToggle,
          cssClass: cssClass,
          disabled: !isOpenDraw,
          icon: 'icon-enkelrader',
          inverted: svs.tipset.models.play.get('isSingleRow'),
          row: 0,
          text: 'Enkelrader',
          transparent: !svs.tipset.models.play.get('isSingleRow')
        });
      }

      contextMenuData.leftButtons.push({
        callback: isRsystem ?
          contextMenuData.onXpertenRsystem :
          contextMenuData.onXperten,
        cssClass: cssClass,
        disabled: disableXperten,
        icon: 'icon-xperten',
        row: 1,
        text:
          isRsystem && svs.core.detect.formfactor.mobile() ?
            'Xperten R-system' :
            'Xperten',
        transparent: true
      });

      contextMenuData.leftButtons.push({
        callback: contextMenuData.onTipsinfo,
        cssClass: cssClass,
        disabled: !isOpenDraw || svs.tipset.models.play.get('isSingleRow'),
        icon: 'icon-tipsinfo',
        row: 1,
        text: 'Tipsinfo',
        transparent: true
      });
      if (
        svs.tipset.models.gameDefinitions.get('hasRAndU') &&
        !isCompetition
      ) {
        contextMenuData.leftButtons.push({
          callback: contextMenuData.onSystemspel,
          cssClass: cssClass,
          disabled: !isOpenDraw || svs.tipset.models.play.get('isSingleRow'),
          icon: 'icon-systemspel',
          row: 1,
          text: 'System',
          transparent: true
        });
      }
      if (
        svs.tipset.models.gameDefinitions.get('productName').toLowerCase() !==
        'topptipset' &&
        svs.tipset.models.gameDefinitions.get('productName').toLowerCase() !==
        'powerplay' &&
        !isCompetition
      ) {
        contextMenuData.leftButtons.push({
          active: svs.tipset.models.play.get('isReduceMode'),
          callback:
            isRsystem || isUsystem ?
              contextMenuData.clearAndToggleReduceMode :
              contextMenuData.toggleReduceMode,
          cssClass: cssClass,
          disabled: !isOpenDraw || svs.tipset.models.play.get('isSingleRow'),
          icon: 'icon-free-reduce',
          row: 1,
          text: 'Reducera fritt',
          transparent: true
        });
      }

      contextMenuData.showMenuInHeader = false;
      contextMenuData.useIconButtons = true;
      contextMenuData.stickyMenuOffset = $('.js-product-base-tabs-nav').height();
      contextMenuData.useFixedMenu = false;
      contextMenuData.contextScrollButtonClass = 'contextual-menu-scroll-button-' + productName;

      if (
        svs.tipset.models.gameDefinitions.get('productName').toLowerCase() === 'stryktipset' &&
        svs.competition &&
        svs.competition.core &&
        svs.competition.core.data.canPlayTipsSM &&
        svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) &&
        svs.competition.Helper.userIsParticipatingInTipsSM()
      ) {
        contextMenuData.leftButtons.push({
          active: window.location.href.indexOf('tipssm') > -1,
          callback: contextMenuData.onTipsSM,
          cssClass: cssClass,
          disabled:
            svs.competition.Helper.userHasPlayedCurrentDraw() ||
            svs.tipset.models.play.get('isSingleRow'),
          icon: 'icon-trophy',
          row: 1,
          text: 'Tips-SM'
        });
      }

      svs.components.contextualMenu.setMenuFunctionality(contextMenuData);
    };
  },

  onDestroy: function() {
    this.stopListening(
      svs.tipset.models.play,
      'change',
      this.setSystemListener
    );
    this.stopListening(svs.tipset.models.systems, 'change', this.update);
  },

  setSystemListener: function() {
    if (!svs.tipset.models.play.get('isSingleRow')) {
      this.listenTo(svs.tipset.models.systems, 'change', this.update);
      this.listenTo(
        svs.tipset.models.xpertenSystems,
        'toggleContextMenu',
        this.toggleVisibility
      );
    } else {
      this.listenTo(
        svs.tipset.models.xpertenSystemsSingleRow,
        'toggleContextMenu',
        this.toggleVisibility
      );
    }
  },

  toggleVisibility: function() {
    if (svs.tipset.models.play.get('isSingleRow') ?
      svs.tipset.models.xpertenSystemsSingleRow.get('generateSystem') :
      svs.tipset.models.xpertenSystems.get('generateSystem')) {
      svs.components.contextualMenu.makeInvisible();
    } else {
      svs.components.contextualMenu.makeVisible();
    }
  },

  update: function() {
    if (!svs.utils.isStartPage && svs.utils.initContextMenu) {
      svs.utils.initContextMenu({});
    }
  }
});

 })(window);